import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import Option from "@/model/option";

@Module({ namespaced: true })
export default class OptionModule extends VuexModule {
  public option: Option = null;
  public optionList: Option[] = [];

  @Mutation
  set(option: Option): void {
    this.option = option;
  }

  @Mutation
  setOptionList(option: Option[]): void {
    this.optionList = option;
  }

  @Mutation
  addOptionList(option: Option): void {
    this.optionList.push(option);
  }

  @Mutation
  editOptionList(option: Option): void {
    this.optionList.map((value, key) => {
      if (value.identifier === option.identifier && value.subIdentifier === option.subIdentifier) {
        this.optionList.splice(key, 1, option)
      }
    });
  }

  @Mutation
  remove(index: number): void {
    this.optionList.splice(index, 1);
  }

  @Action({ rawError: true })
  setOption(option: Option) {
    this.context.commit("set", option);
  }

  @Action({ rawError: true })
  addOptionToList(option: Option) {
    this.context.commit("addOptionList", option);
  }

  @Action({ rawError: true })
  editOptionToList(option: Option) {
    this.context.commit("editOptionList", option);
  }

  @Action({ rawError: true })
  removeOptionInList(index: number) {
    this.context.commit("remove", index);
  }

  @Action({ rawError: true })
  clear() {
    this.context.commit("set", null);
  }

  @Action({ rawError: true })
  clearList() {
    this.context.commit("setOptionList", []);
  }

  get getOption(): Option {
    return this.option;
  }

  get getOptionList(): Option[] {
    return this.optionList;
  }

  @Mutation
  setQuantity(value: any): void {
    this.optionList.map(item => {
      if (item.identifier === value.identifier) {
        item.quantity = value.quantity
      }
    })
  }

  @Action({ rawError: true })
  setQuantityToOptionItem(value: any) {
    this.context.commit("setQuantity", value);
  }

}
